<template>
  <RevButton
    v-if="!tiny"
    data-qa="print-purchase-proof"
    data-test="print-purchase-proof"
    full-width="responsive"
    target="_blank"
    :to="saleCertificateUrl"
    :variant="variant"
  >
    {{ i18n(translations.label) }}
  </RevButton>

  <RevButtonTiny
    v-else
    class="w-fit"
    data-qa="print-purchase-proof"
    data-test="print-purchase-proof"
    :icon="IconDownload"
    target="_blank"
    :to="saleCertificateUrl"
    :variant="variant"
  >
    {{ i18n(translations.label) }}
  </RevButtonTiny>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevButtonTiny } from '@ds/components/ButtonTiny'
import { IconDownload } from '@ds/icons/IconDownload'

import translations from './ProofOfPurchaseAction.translations'
import type { ProofOfPurchaseActionProps } from './ProofOfPurchaseAction.types'

const { orderId, tiny, variant } = withDefaults(
  defineProps<ProofOfPurchaseActionProps>(),
  {
    tiny: false,
    variant: 'secondary',
  },
)

const i18n = useI18n()

const saleCertificateUrl = {
  type: 'external',
  href: `/bm/order/${orderId}/sale_certificate`,
}
</script>
